import {
  ForgeDarkIcon,
  ForgeLightIcon,
  SpectraDarkSvg,
  SpectraSvg,
} from "../../assets";
import { useTheme } from "../../context/ThemeProvider";

export const HeaderSpectraLogo = ({ spaceName }) => {
  const { theme, colorScheme } = useTheme();
  return (
    <div className="flex shrink-0 items-center sm:gap-2">
      <div className="flex items-center">
        {colorScheme === "docs" ? <SpectraSvg className="photon-navigation-icon photon-product-icon text-ink-primary" aria-hidden="true" /> : theme === "dark" ? <SpectraDarkSvg className="photon-navigation-icon" /> : <SpectraSvg className="photon-navigation-icon" />}
        <span className="hidden sm:inline text-ink-ink dark:text-ink-white text-lg font-semibold ml-2">
          Spectra{spaceName ? <><span className="font-bold text-ink-canvas-accent mx-1.5">/</span><span className="font-normal">{spaceName}</span></> : null}
        </span>
      </div>
      <div className="hidden sm:block border-l border-edge-border dark:border-edge-muted-control ml-1"></div>
    </div>
  );
};

export const HeaderForgeLogo = () => {
  const { theme, colorScheme } = useTheme();
  return (
    <div className="flex items-center">
      {colorScheme === "docs" ? <ForgeLightIcon className="photon-navigation-icon photon-product-icon text-ink-primary" aria-hidden="true" /> : theme === "dark" ? <ForgeDarkIcon className="photon-navigation-icon" /> : <ForgeLightIcon className="photon-navigation-icon" />}
      <span className="hidden sm:inline text-ink-ink dark:text-ink-white text-lg font-semibold ml-2">
        Forge
      </span>
    </div>
  );
};
